<h2 mat-dialog-title>Create New Account</h2>
<mat-dialog-content style="height: 120px;">
  <form [formGroup]="newAccountForm">
    <mat-form-field appearance="fill" style="width:100%">
      <mat-label>Account Name</mat-label>
      <input matInput placeholder="Enter the name of new account" formControlName="accountName" />
      <mat-error *ngIf="newAccountForm.controls['accountName'].invalid && (newAccountForm.controls['accountName'].touched || newAccountForm.controls['accountName'].dirty)">
        <p *ngIf="newAccountForm.controls['accountName'].errors.required">Account name is <strong>required</strong></p>
        <p *ngIf="newAccountForm.controls['accountName'].errors.maxlength">Account name can not exceed <strong>256</strong> characters.</p>
      </mat-error>
    </mat-form-field>
    <mat-checkbox matInput style="padding-top: 15px; padding-left: 5px; width: 100%;" formControlName="isHibernated" (change)="updateAccountName($event.checked)">Create Account as Hibernated</mat-checkbox>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitNewAccountForm" [disabled]="!newAccountForm.valid" (click)="addNewAccount()">Add Account</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
